import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { Link } from 'react-router-dom';
import { AlertCircle, CheckCircle2, Loader2 } from 'lucide-react';
import './auth.css';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const { requestPasswordReset } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const data = await requestPasswordReset(email);
            setSuccess(data.message);
        } catch (err) {
            setError(err.response?.data?.error || 'Не удалось отправить ссылку. Попробуйте позже.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-screen">
            <div className="auth-wrap">
                <p className="auth-brand">PASSX</p>

                <div className="auth-panel">
                    <header className="auth-head">
                        <h1 className="auth-title">Восстановление пароля</h1>
                        <p className="auth-lead">
                            Укажите email, с которым регистрировались. Пришлём ссылку для нового пароля
                            на почту, а если подключён Telegram — и туда.
                        </p>
                    </header>

                    {error && (
                        <div className="auth-alert auth-alert--warn" role="alert" id="forgot-error">
                            <AlertCircle size={20} aria-hidden="true" />
                            <span>{error}</span>
                        </div>
                    )}

                    {success ? (
                        <div className="auth-alert auth-alert--ok" role="status">
                            <CheckCircle2 size={20} aria-hidden="true" />
                            <span>{success} Если письма нет, проверьте папку «Спам».</span>
                        </div>
                    ) : (
                        <form className="auth-form-body" onSubmit={handleSubmit}>
                            <div className="auth-field">
                                <label className="auth-label" htmlFor="forgot-email">Email</label>
                                <input
                                    id="forgot-email"
                                    className="auth-input"
                                    type="email"
                                    autoComplete="email"
                                    autoCapitalize="none"
                                    spellCheck={false}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    placeholder="email@example.com"
                                    aria-invalid={error ? 'true' : undefined}
                                    aria-describedby={error ? 'forgot-error' : undefined}
                                />
                            </div>
                            <button
                                className="auth-submit"
                                type="submit"
                                disabled={loading}
                                aria-busy={loading ? 'true' : undefined}
                            >
                                {loading && <Loader2 size={20} className="auth-spin" aria-hidden="true" />}
                                {loading ? 'Отправка...' : 'Прислать ссылку'}
                            </button>
                        </form>
                    )}

                    <p className="auth-switch">
                        Вспомнили пароль? <Link className="auth-link" to="/login">Войти</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
